// JsFromRoutes CacheKey 1edec9e48b02507a2aecf029bf155333
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const incidents = {
  list: definePathHelper("get", "/incidents"),
};
